// @flow

import addEstimateGroup from '../../../Services/addEstimateGroup';

export default () => async (dispatch: Function) => dispatch(addEstimateGroup())